export default `mutation createRmaExt( $inputRma: CreateRmaInput!) {
  createRmaExt(input: $inputRma ) {
    rma {
      increment_id
      status_id
      guest_id
    }
  }
}`
